module.exports = __webpack_public_path__ + "assets/img/shop_tit1.81b18438.png";